export enum TimeTrackingCreateOinPreferenceEnum {
  WORKING_DAY_BEFORE_BILLING_DAY = 'WORKING_DAY_BEFORE_BILLING_DAY',
  WORKING_DAY_AFTER_BILLING_DAY = 'WORKING_DAY_AFTER_BILLING_DAY',
}
